import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { gql, GqlRequestHeaders } from './fetcher';
import * as Types from './types';

export const CreateAdAgencyAgencyManagerTypeDocument = `
    mutation CreateAdAgencyAgencyManagerType($input: CreateAdAgencyAgencyManagerTypeInput) {
  create_ad_agency_agency_manager_type: createAdAgencyAgencyManagerType(
    input: $input
  )
}
    `;

export const useCreateAdAgencyAgencyManagerTypeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.CreateAdAgencyAgencyManagerTypeMutation,
    TError,
    Types.CreateAdAgencyAgencyManagerTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.CreateAdAgencyAgencyManagerTypeMutation,
    TError,
    Types.CreateAdAgencyAgencyManagerTypeMutationVariables,
    TContext
  >({
    mutationKey: ['CreateAdAgencyAgencyManagerType'],
    mutationFn: (variables?: Types.CreateAdAgencyAgencyManagerTypeMutationVariables) =>
      gql<Types.CreateAdAgencyAgencyManagerTypeMutation, Types.CreateAdAgencyAgencyManagerTypeMutationVariables>(
        CreateAdAgencyAgencyManagerTypeDocument,
        variables,
      )(),
    ...options,
  });
};

export const DeleteAdAgencyAgencyManagerDocument = `
    mutation DeleteAdAgencyAgencyManager($input: DeleteAdAgencyAgencyManagerInput) {
  delete_ad_agency_agency_manager: deleteAdAgencyAgencyManager(input: $input)
}
    `;

export const useDeleteAdAgencyAgencyManagerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.DeleteAdAgencyAgencyManagerMutation,
    TError,
    Types.DeleteAdAgencyAgencyManagerMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.DeleteAdAgencyAgencyManagerMutation,
    TError,
    Types.DeleteAdAgencyAgencyManagerMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteAdAgencyAgencyManager'],
    mutationFn: (variables?: Types.DeleteAdAgencyAgencyManagerMutationVariables) =>
      gql<Types.DeleteAdAgencyAgencyManagerMutation, Types.DeleteAdAgencyAgencyManagerMutationVariables>(
        DeleteAdAgencyAgencyManagerDocument,
        variables,
      )(),
    ...options,
  });
};

export const InviteAdAgencyMarketerDocument = `
    mutation InviteAdAgencyMarketer($input: InviteAdAgencyMarketerInput) {
  invite_ad_agency_marketer: inviteAdAgencyMarketer(input: $input)
}
    `;

export const useInviteAdAgencyMarketerMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.InviteAdAgencyMarketerMutation,
    TError,
    Types.InviteAdAgencyMarketerMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.InviteAdAgencyMarketerMutation,
    TError,
    Types.InviteAdAgencyMarketerMutationVariables,
    TContext
  >({
    mutationKey: ['InviteAdAgencyMarketer'],
    mutationFn: (variables?: Types.InviteAdAgencyMarketerMutationVariables) =>
      gql<Types.InviteAdAgencyMarketerMutation, Types.InviteAdAgencyMarketerMutationVariables>(
        InviteAdAgencyMarketerDocument,
        variables,
      )(),
    ...options,
  });
};

export const RequestAdAgencyControlStatusDocument = `
    mutation RequestAdAgencyControlStatus($input: RequestAdAgencyControlStatusInput) {
  request_ad_agency_control_status: requestAdAgencyControlStatus(input: $input)
}
    `;

export const useRequestAdAgencyControlStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.RequestAdAgencyControlStatusMutation,
    TError,
    Types.RequestAdAgencyControlStatusMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.RequestAdAgencyControlStatusMutation,
    TError,
    Types.RequestAdAgencyControlStatusMutationVariables,
    TContext
  >({
    mutationKey: ['RequestAdAgencyControlStatus'],
    mutationFn: (variables?: Types.RequestAdAgencyControlStatusMutationVariables) =>
      gql<Types.RequestAdAgencyControlStatusMutation, Types.RequestAdAgencyControlStatusMutationVariables>(
        RequestAdAgencyControlStatusDocument,
        variables,
      )(),
    ...options,
  });
};

export const RemoveAdAgencyFromSellerAccountDocument = `
    mutation RemoveAdAgencyFromSellerAccount($input: RemoveAdAgencyFromSellerAccountInput!) {
  remove_ad_agency_from_seller_account: removeAdAgencyFromSellerAccount(
    input: $input
  )
}
    `;

export const useRemoveAdAgencyFromSellerAccountMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.RemoveAdAgencyFromSellerAccountMutation,
    TError,
    Types.RemoveAdAgencyFromSellerAccountMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.RemoveAdAgencyFromSellerAccountMutation,
    TError,
    Types.RemoveAdAgencyFromSellerAccountMutationVariables,
    TContext
  >({
    mutationKey: ['RemoveAdAgencyFromSellerAccount'],
    mutationFn: (variables?: Types.RemoveAdAgencyFromSellerAccountMutationVariables) =>
      gql<Types.RemoveAdAgencyFromSellerAccountMutation, Types.RemoveAdAgencyFromSellerAccountMutationVariables>(
        RemoveAdAgencyFromSellerAccountDocument,
        variables,
      )(),
    ...options,
  });
};

export const DownloadAdAgencyAdAllPerformanceReportListDocument = `
    mutation DownloadAdAgencyAdAllPerformanceReportList($input: DownloadAdAgencyAdAllPerformanceReportListInput!) {
  download_ad_agency_ad_all_performance_report_list: downloadAdAgencyAdAllPerformanceReportList(
    input: $input
  ) {
    presigned_s3_url
  }
}
    `;

export const useDownloadAdAgencyAdAllPerformanceReportListMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.DownloadAdAgencyAdAllPerformanceReportListMutation,
    TError,
    Types.DownloadAdAgencyAdAllPerformanceReportListMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.DownloadAdAgencyAdAllPerformanceReportListMutation,
    TError,
    Types.DownloadAdAgencyAdAllPerformanceReportListMutationVariables,
    TContext
  >({
    mutationKey: ['DownloadAdAgencyAdAllPerformanceReportList'],
    mutationFn: (variables?: Types.DownloadAdAgencyAdAllPerformanceReportListMutationVariables) =>
      gql<
        Types.DownloadAdAgencyAdAllPerformanceReportListMutation,
        Types.DownloadAdAgencyAdAllPerformanceReportListMutationVariables
      >(DownloadAdAgencyAdAllPerformanceReportListDocument, variables)(),
    ...options,
  });
};

export const DownloadAdAgencyAdTopStorePerformanceReportListDocument = `
    mutation DownloadAdAgencyAdTopStorePerformanceReportList($input: DownloadAdAgencyAdTopStorePerformanceReportListInput!) {
  download_ad_agency_ad_top_store_performance_report_list: downloadAdAgencyAdTopStorePerformanceReportList(
    input: $input
  ) {
    presigned_s3_url
  }
}
    `;

export const useDownloadAdAgencyAdTopStorePerformanceReportListMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.DownloadAdAgencyAdTopStorePerformanceReportListMutation,
    TError,
    Types.DownloadAdAgencyAdTopStorePerformanceReportListMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.DownloadAdAgencyAdTopStorePerformanceReportListMutation,
    TError,
    Types.DownloadAdAgencyAdTopStorePerformanceReportListMutationVariables,
    TContext
  >({
    mutationKey: ['DownloadAdAgencyAdTopStorePerformanceReportList'],
    mutationFn: (variables?: Types.DownloadAdAgencyAdTopStorePerformanceReportListMutationVariables) =>
      gql<
        Types.DownloadAdAgencyAdTopStorePerformanceReportListMutation,
        Types.DownloadAdAgencyAdTopStorePerformanceReportListMutationVariables
      >(DownloadAdAgencyAdTopStorePerformanceReportListDocument, variables)(),
    ...options,
  });
};

export const DownloadAdAgencyAdMarketerPerformanceReportListDocument = `
    mutation DownloadAdAgencyAdMarketerPerformanceReportList($input: DownloadAdAgencyAdMarketerPerformanceReportListInput!) {
  download_ad_agency_ad_marketer_performance_report_list: downloadAdAgencyAdMarketerPerformanceReportList(
    input: $input
  ) {
    presigned_s3_url
  }
}
    `;

export const useDownloadAdAgencyAdMarketerPerformanceReportListMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.DownloadAdAgencyAdMarketerPerformanceReportListMutation,
    TError,
    Types.DownloadAdAgencyAdMarketerPerformanceReportListMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.DownloadAdAgencyAdMarketerPerformanceReportListMutation,
    TError,
    Types.DownloadAdAgencyAdMarketerPerformanceReportListMutationVariables,
    TContext
  >({
    mutationKey: ['DownloadAdAgencyAdMarketerPerformanceReportList'],
    mutationFn: (variables?: Types.DownloadAdAgencyAdMarketerPerformanceReportListMutationVariables) =>
      gql<
        Types.DownloadAdAgencyAdMarketerPerformanceReportListMutation,
        Types.DownloadAdAgencyAdMarketerPerformanceReportListMutationVariables
      >(DownloadAdAgencyAdMarketerPerformanceReportListDocument, variables)(),
    ...options,
  });
};

export const DownloadAdAgencySettlementReportListDocument = `
    mutation DownloadAdAgencySettlementReportList($input: DownloadAdAgencySettlementReportListInput!) {
  download_ad_agency_settlement_report_list: downloadAdAgencySettlementReportList(
    input: $input
  ) {
    presigned_s3_url
  }
}
    `;

export const useDownloadAdAgencySettlementReportListMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.DownloadAdAgencySettlementReportListMutation,
    TError,
    Types.DownloadAdAgencySettlementReportListMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.DownloadAdAgencySettlementReportListMutation,
    TError,
    Types.DownloadAdAgencySettlementReportListMutationVariables,
    TContext
  >({
    mutationKey: ['DownloadAdAgencySettlementReportList'],
    mutationFn: (variables?: Types.DownloadAdAgencySettlementReportListMutationVariables) =>
      gql<
        Types.DownloadAdAgencySettlementReportListMutation,
        Types.DownloadAdAgencySettlementReportListMutationVariables
      >(DownloadAdAgencySettlementReportListDocument, variables)(),
    ...options,
  });
};

export const CreateAgencyWithAccountDocument = `
    mutation CreateAgencyWithAccount($input: CreateAgencyWithAccountInput!) {
  create_agency_with_account: createAgencyWithAccount(input: $input)
}
    `;

export const useCreateAgencyWithAccountMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.CreateAgencyWithAccountMutation,
    TError,
    Types.CreateAgencyWithAccountMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.CreateAgencyWithAccountMutation,
    TError,
    Types.CreateAgencyWithAccountMutationVariables,
    TContext
  >({
    mutationKey: ['CreateAgencyWithAccount'],
    mutationFn: (variables?: Types.CreateAgencyWithAccountMutationVariables) =>
      gql<Types.CreateAgencyWithAccountMutation, Types.CreateAgencyWithAccountMutationVariables>(
        CreateAgencyWithAccountDocument,
        variables,
      )(),
    ...options,
  });
};

export const RequestBulkExcelDownloadDocument = `
    mutation RequestBulkExcelDownload($input: RequestBulkExcelDownloadInput!) {
  request_excel_download: requestBulkExcelDownload(input: $input) {
    id
    template_name
    title
    parameters
    status
    file_name
    created_by
    updated_by
    date_created
    date_updated
  }
}
    `;

export const useRequestBulkExcelDownloadMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.RequestBulkExcelDownloadMutation,
    TError,
    Types.RequestBulkExcelDownloadMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.RequestBulkExcelDownloadMutation,
    TError,
    Types.RequestBulkExcelDownloadMutationVariables,
    TContext
  >({
    mutationKey: ['RequestBulkExcelDownload'],
    mutationFn: (variables?: Types.RequestBulkExcelDownloadMutationVariables) =>
      gql<Types.RequestBulkExcelDownloadMutation, Types.RequestBulkExcelDownloadMutationVariables>(
        RequestBulkExcelDownloadDocument,
        variables,
      )(),
    ...options,
  });
};

export const GetBulkExcelDownloadUrlDocument = `
    mutation GetBulkExcelDownloadUrl($request_id: ID!) {
  get_excel_download_url: getBulkExcelDownloadUrl(request_id: $request_id) {
    presigned_s3_url
    duration_ms
  }
}
    `;

export const useGetBulkExcelDownloadUrlMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.GetBulkExcelDownloadUrlMutation,
    TError,
    Types.GetBulkExcelDownloadUrlMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.GetBulkExcelDownloadUrlMutation,
    TError,
    Types.GetBulkExcelDownloadUrlMutationVariables,
    TContext
  >({
    mutationKey: ['GetBulkExcelDownloadUrl'],
    mutationFn: (variables?: Types.GetBulkExcelDownloadUrlMutationVariables) =>
      gql<Types.GetBulkExcelDownloadUrlMutation, Types.GetBulkExcelDownloadUrlMutationVariables>(
        GetBulkExcelDownloadUrlDocument,
        variables,
      )(),
    ...options,
  });
};

export const GetAdAgencyDocument = `
    query GetAdAgency {
  ad_agency {
    id
    name
    contact_name
    contact_tel
    payment_manager_email
    status
    date_status_changed
    business_license_url
    bankbook_url
    penalty_point
    payment_info {
      bank_code
      account_number
      account_holder
    }
  }
}
    `;

export const useGetAdAgencyQuery = <TData = Types.GetAdAgencyQuery, TError = unknown>(
  variables?: Types.GetAdAgencyQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdAgency'] : ['GetAdAgency', variables],
    queryFn: gql<Types.GetAdAgencyQuery, Types.GetAdAgencyQueryVariables>(GetAdAgencyDocument, variables),
    ...options,
  });
};

useGetAdAgencyQuery.getKey = (variables?: Types.GetAdAgencyQueryVariables) =>
  variables === undefined ? ['GetAdAgency'] : ['GetAdAgency', variables];

export const GetAdAgencyListDocument = `
    query GetAdAgencyList {
  ad_agency_list {
    item_list {
      id
      name
      contact_name
      contact_tel
      payment_manager_email
      status
      date_status_changed
      business_license_url
      bankbook_url
      penalty_point
      payment_info {
        bank_code
        account_number
        account_holder
      }
    }
  }
}
    `;

export const useGetAdAgencyListQuery = <TData = Types.GetAdAgencyListQuery, TError = unknown>(
  variables?: Types.GetAdAgencyListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyListQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdAgencyList'] : ['GetAdAgencyList', variables],
    queryFn: gql<Types.GetAdAgencyListQuery, Types.GetAdAgencyListQueryVariables>(GetAdAgencyListDocument, variables),
    ...options,
  });
};

useGetAdAgencyListQuery.getKey = (variables?: Types.GetAdAgencyListQueryVariables) =>
  variables === undefined ? ['GetAdAgencyList'] : ['GetAdAgencyList', variables];

export const GetAdAgencyControlStatusDocument = `
    query GetAdAgencyControlStatus($agency_account_id: ID) {
  ad_agency_control_status(agency_account_id: $agency_account_id) {
    item_list {
      shop_id
      shop {
        shop_id
        name
        shop_domain
      }
      status
      date_requested
      date_approved
      date_stopped
      date_rejected
      agency_manager_list {
        id
        shop_manager_id
        name
        phone_number
        identifier
        agency_manager_type
      }
      insight_subscription_name
      shop_promotion_type_list
      is_privacy_agreement
    }
    transfer_request_list {
      shop_id
      shop {
        shop_id
        name
        shop_domain
      }
      date_requested
    }
  }
}
    `;

export const useGetAdAgencyControlStatusQuery = <TData = Types.GetAdAgencyControlStatusQuery, TError = unknown>(
  variables?: Types.GetAdAgencyControlStatusQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyControlStatusQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyControlStatusQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyControlStatusQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdAgencyControlStatus'] : ['GetAdAgencyControlStatus', variables],
    queryFn: gql<Types.GetAdAgencyControlStatusQuery, Types.GetAdAgencyControlStatusQueryVariables>(
      GetAdAgencyControlStatusDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencyControlStatusQuery.getKey = (variables?: Types.GetAdAgencyControlStatusQueryVariables) =>
  variables === undefined ? ['GetAdAgencyControlStatus'] : ['GetAdAgencyControlStatus', variables];

export const GetAdAgencySalesListDocument = `
    query GetAdAgencySalesList($store_name: String!) {
  ad_agency_sales_list(store_name: $store_name) {
    item_list {
      shop_id
      store_name
      business_number
      is_agency
      is_agency_sales
      is_requested
      is_agency_store
      shop_domain
      is_privacy_agreement
    }
  }
}
    `;

export const useGetAdAgencySalesListQuery = <TData = Types.GetAdAgencySalesListQuery, TError = unknown>(
  variables: Types.GetAdAgencySalesListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencySalesListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencySalesListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencySalesListQuery, TError, TData>({
    queryKey: ['GetAdAgencySalesList', variables],
    queryFn: gql<Types.GetAdAgencySalesListQuery, Types.GetAdAgencySalesListQueryVariables>(
      GetAdAgencySalesListDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencySalesListQuery.getKey = (variables: Types.GetAdAgencySalesListQueryVariables) => [
  'GetAdAgencySalesList',
  variables,
];

export const GetAdAgencyMarketerListDocument = `
    query GetAdAgencyMarketerList {
  ad_agency_marketer_list {
    item_list {
      id
      agency_id
      name
      phone_number
      identifier
      shop_list {
        shop_id
        name
        shop_domain
      }
    }
  }
}
    `;

export const useGetAdAgencyMarketerListQuery = <TData = Types.GetAdAgencyMarketerListQuery, TError = unknown>(
  variables?: Types.GetAdAgencyMarketerListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyMarketerListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyMarketerListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyMarketerListQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdAgencyMarketerList'] : ['GetAdAgencyMarketerList', variables],
    queryFn: gql<Types.GetAdAgencyMarketerListQuery, Types.GetAdAgencyMarketerListQueryVariables>(
      GetAdAgencyMarketerListDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencyMarketerListQuery.getKey = (variables?: Types.GetAdAgencyMarketerListQueryVariables) =>
  variables === undefined ? ['GetAdAgencyMarketerList'] : ['GetAdAgencyMarketerList', variables];

export const GetAdPartnerShopContactDocument = `
    query GetAdPartnerShopContact($shop_domain: String!) {
  ad_partner_shop_contact(shop_domain: $shop_domain) {
    name
    email
    mobile_number
  }
}
    `;

export const useGetAdPartnerShopContactQuery = <TData = Types.GetAdPartnerShopContactQuery, TError = unknown>(
  variables: Types.GetAdPartnerShopContactQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdPartnerShopContactQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdPartnerShopContactQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdPartnerShopContactQuery, TError, TData>({
    queryKey: ['GetAdPartnerShopContact', variables],
    queryFn: gql<Types.GetAdPartnerShopContactQuery, Types.GetAdPartnerShopContactQueryVariables>(
      GetAdPartnerShopContactDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdPartnerShopContactQuery.getKey = (variables: Types.GetAdPartnerShopContactQueryVariables) => [
  'GetAdPartnerShopContact',
  variables,
];

export const GetAdAgencyNoticeListDocument = `
    query GetAdAgencyNoticeList($search_text: String, $notice_category: String) {
  ad_agency_notice_list(
    search_text: $search_text
    notice_category: $notice_category
  ) {
    item_list {
      id
      title
      created_at
      date_started
      is_pinned
      notice_category
    }
  }
}
    `;

export const useGetAdAgencyNoticeListQuery = <TData = Types.GetAdAgencyNoticeListQuery, TError = unknown>(
  variables?: Types.GetAdAgencyNoticeListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyNoticeListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyNoticeListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyNoticeListQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdAgencyNoticeList'] : ['GetAdAgencyNoticeList', variables],
    queryFn: gql<Types.GetAdAgencyNoticeListQuery, Types.GetAdAgencyNoticeListQueryVariables>(
      GetAdAgencyNoticeListDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencyNoticeListQuery.getKey = (variables?: Types.GetAdAgencyNoticeListQueryVariables) =>
  variables === undefined ? ['GetAdAgencyNoticeList'] : ['GetAdAgencyNoticeList', variables];

export const GetAdAgencyPenaltyListDocument = `
    query GetAdAgencyPenaltyList {
  ad_agency_penalty_list {
    item_list {
      id
      penalty_point
      penalty_type
      penalty_type_text
      penalty_sub_type
      penalty_sub_type_text
      memo
      created_at
      created_by
      updated_at
      updated_by
    }
  }
}
    `;

export const useGetAdAgencyPenaltyListQuery = <TData = Types.GetAdAgencyPenaltyListQuery, TError = unknown>(
  variables?: Types.GetAdAgencyPenaltyListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyPenaltyListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyPenaltyListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyPenaltyListQuery, TError, TData>({
    queryKey: variables === undefined ? ['GetAdAgencyPenaltyList'] : ['GetAdAgencyPenaltyList', variables],
    queryFn: gql<Types.GetAdAgencyPenaltyListQuery, Types.GetAdAgencyPenaltyListQueryVariables>(
      GetAdAgencyPenaltyListDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencyPenaltyListQuery.getKey = (variables?: Types.GetAdAgencyPenaltyListQueryVariables) =>
  variables === undefined ? ['GetAdAgencyPenaltyList'] : ['GetAdAgencyPenaltyList', variables];

export const GetAdAgencyNoticeDocument = `
    query GetAdAgencyNotice($notice_id: ID!) {
  ad_agency_notice(notice_id: $notice_id) {
    id
    title
    contents
    notice_status
    is_pinned
    attached_file_list
    created_at
    date_started
    display_agency_id_list
    notice_category
  }
}
    `;

export const useGetAdAgencyNoticeQuery = <TData = Types.GetAdAgencyNoticeQuery, TError = unknown>(
  variables: Types.GetAdAgencyNoticeQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyNoticeQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyNoticeQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyNoticeQuery, TError, TData>({
    queryKey: ['GetAdAgencyNotice', variables],
    queryFn: gql<Types.GetAdAgencyNoticeQuery, Types.GetAdAgencyNoticeQueryVariables>(
      GetAdAgencyNoticeDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencyNoticeQuery.getKey = (variables: Types.GetAdAgencyNoticeQueryVariables) => [
  'GetAdAgencyNotice',
  variables,
];

export const GetAdAgencyAdPerformanceInfoDocument = `
    query GetAdAgencyAdPerformanceInfo($date_gte: CrTimestamp!, $date_lte: CrTimestamp!) {
  ad_agency_ad_performance_info(date_gte: $date_gte, date_lte: $date_lte) {
    agency_ad_performance_ranking
    zz_cash_amount
    zz_point_amount
    zz_total_amount
    zz_total_zpay_paid_amount
    fbk_cash_amount
    fbk_point_amount
    fbk_total_amount
    fbk_total_zpay_paid_amount
  }
}
    `;

export const useGetAdAgencyAdPerformanceInfoQuery = <TData = Types.GetAdAgencyAdPerformanceInfoQuery, TError = unknown>(
  variables: Types.GetAdAgencyAdPerformanceInfoQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyAdPerformanceInfoQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyAdPerformanceInfoQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyAdPerformanceInfoQuery, TError, TData>({
    queryKey: ['GetAdAgencyAdPerformanceInfo', variables],
    queryFn: gql<Types.GetAdAgencyAdPerformanceInfoQuery, Types.GetAdAgencyAdPerformanceInfoQueryVariables>(
      GetAdAgencyAdPerformanceInfoDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencyAdPerformanceInfoQuery.getKey = (variables: Types.GetAdAgencyAdPerformanceInfoQueryVariables) => [
  'GetAdAgencyAdPerformanceInfo',
  variables,
];

export const GetAdAgencyAdAllPerformanceReportListDocument = `
    query GetAdAgencyAdAllPerformanceReportList($date_gte: CrTimestamp!, $date_lte: CrTimestamp!) {
  ad_agency_ad_all_performance_report_list(
    date_gte: $date_gte
    date_lte: $date_lte
  ) {
    item_list {
      date
      basic_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
    }
  }
}
    `;

export const useGetAdAgencyAdAllPerformanceReportListQuery = <
  TData = Types.GetAdAgencyAdAllPerformanceReportListQuery,
  TError = unknown,
>(
  variables: Types.GetAdAgencyAdAllPerformanceReportListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyAdAllPerformanceReportListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyAdAllPerformanceReportListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyAdAllPerformanceReportListQuery, TError, TData>({
    queryKey: ['GetAdAgencyAdAllPerformanceReportList', variables],
    queryFn: gql<
      Types.GetAdAgencyAdAllPerformanceReportListQuery,
      Types.GetAdAgencyAdAllPerformanceReportListQueryVariables
    >(GetAdAgencyAdAllPerformanceReportListDocument, variables),
    ...options,
  });
};

useGetAdAgencyAdAllPerformanceReportListQuery.getKey = (
  variables: Types.GetAdAgencyAdAllPerformanceReportListQueryVariables,
) => ['GetAdAgencyAdAllPerformanceReportList', variables];

export const GetAdAgencyAdMarketerPerformanceReportListDocument = `
    query GetAdAgencyAdMarketerPerformanceReportList($comparison_type: String!, $agency_account_id: ID, $date_gte: CrTimestamp!, $date_lte: CrTimestamp!, $page: Int, $page_size: Int) {
  ad_agency_ad_marketer_performance_report_list(
    comparison_type: $comparison_type
    agency_account_id: $agency_account_id
    date_gte: $date_gte
    date_lte: $date_lte
    page: $page
    page_size: $page_size
  ) {
    total_count
    item_list {
      agency_account_id
      marketer_name
      operation_store_cnt
      current_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
      past_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
    }
  }
}
    `;

export const useGetAdAgencyAdMarketerPerformanceReportListQuery = <
  TData = Types.GetAdAgencyAdMarketerPerformanceReportListQuery,
  TError = unknown,
>(
  variables: Types.GetAdAgencyAdMarketerPerformanceReportListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyAdMarketerPerformanceReportListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyAdMarketerPerformanceReportListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyAdMarketerPerformanceReportListQuery, TError, TData>({
    queryKey: ['GetAdAgencyAdMarketerPerformanceReportList', variables],
    queryFn: gql<
      Types.GetAdAgencyAdMarketerPerformanceReportListQuery,
      Types.GetAdAgencyAdMarketerPerformanceReportListQueryVariables
    >(GetAdAgencyAdMarketerPerformanceReportListDocument, variables),
    ...options,
  });
};

useGetAdAgencyAdMarketerPerformanceReportListQuery.getKey = (
  variables: Types.GetAdAgencyAdMarketerPerformanceReportListQueryVariables,
) => ['GetAdAgencyAdMarketerPerformanceReportList', variables];

export const GetAdAgencyAdTopStorePerformanceReportListDocument = `
    query GetAdAgencyAdTopStorePerformanceReportList($comparison_type: String!, $date_gte: CrTimestamp!, $date_lte: CrTimestamp!) {
  ad_agency_ad_top_store_performance_report_list(
    comparison_type: $comparison_type
    date_gte: $date_gte
    date_lte: $date_lte
  ) {
    item_list {
      shop_id
      shop_domain
      shop_name
      vvip_grade
      current_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
      past_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
    }
  }
}
    `;

export const useGetAdAgencyAdTopStorePerformanceReportListQuery = <
  TData = Types.GetAdAgencyAdTopStorePerformanceReportListQuery,
  TError = unknown,
>(
  variables: Types.GetAdAgencyAdTopStorePerformanceReportListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencyAdTopStorePerformanceReportListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencyAdTopStorePerformanceReportListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencyAdTopStorePerformanceReportListQuery, TError, TData>({
    queryKey: ['GetAdAgencyAdTopStorePerformanceReportList', variables],
    queryFn: gql<
      Types.GetAdAgencyAdTopStorePerformanceReportListQuery,
      Types.GetAdAgencyAdTopStorePerformanceReportListQueryVariables
    >(GetAdAgencyAdTopStorePerformanceReportListDocument, variables),
    ...options,
  });
};

useGetAdAgencyAdTopStorePerformanceReportListQuery.getKey = (
  variables: Types.GetAdAgencyAdTopStorePerformanceReportListQueryVariables,
) => ['GetAdAgencyAdTopStorePerformanceReportList', variables];

export const GetAdAgencySalesPerformanceReportListDocument = `
    query GetAdAgencySalesPerformanceReportList($date_gte: CrTimestamp!, $date_lte: CrTimestamp!) {
  ad_agency_sales_performance_report_list(
    date_gte: $date_gte
    date_lte: $date_lte
  ) {
    item_list {
      agency_id
      agency_sales_performance_ranking
      new_store_count
      transfer_store_count
      canceled_store_count
    }
  }
}
    `;

export const useGetAdAgencySalesPerformanceReportListQuery = <
  TData = Types.GetAdAgencySalesPerformanceReportListQuery,
  TError = unknown,
>(
  variables: Types.GetAdAgencySalesPerformanceReportListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencySalesPerformanceReportListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencySalesPerformanceReportListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencySalesPerformanceReportListQuery, TError, TData>({
    queryKey: ['GetAdAgencySalesPerformanceReportList', variables],
    queryFn: gql<
      Types.GetAdAgencySalesPerformanceReportListQuery,
      Types.GetAdAgencySalesPerformanceReportListQueryVariables
    >(GetAdAgencySalesPerformanceReportListDocument, variables),
    ...options,
  });
};

useGetAdAgencySalesPerformanceReportListQuery.getKey = (
  variables: Types.GetAdAgencySalesPerformanceReportListQueryVariables,
) => ['GetAdAgencySalesPerformanceReportList', variables];

export const GetAdAgencySettlementReportListDocument = `
    query GetAdAgencySettlementReportList($agency_account_id: ID, $date_gte: CrTimestamp!, $date_lte: CrTimestamp!, $page: Int, $page_size: Int) {
  ad_agency_settlement_report_list(
    agency_account_id: $agency_account_id
    date_gte: $date_gte
    date_lte: $date_lte
    page: $page
    page_size: $page_size
  ) {
    total_count
    total_result {
      agency_fee
      agency_vat
      shop_total_count
      total_amount
      basic_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
    }
    item_list {
      date
      shop_id
      shop_name
      shop_domain
      total_amount
      agency_fee
      agency_vat
      basic_data {
        cash_amount_zz_prod
        point_amount_zz_prod
        cash_amount_zz_att
        point_amount_zz_att
        cash_amount_zz_msg
        point_amount_zz_msg
        cash_amount_fbk_prod
        point_amount_fbk_prod
        zz_total_zpay_paid_amount
        fbk_total_zpay_paid_amount
      }
    }
  }
}
    `;

export const useGetAdAgencySettlementReportListQuery = <
  TData = Types.GetAdAgencySettlementReportListQuery,
  TError = unknown,
>(
  variables: Types.GetAdAgencySettlementReportListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetAdAgencySettlementReportListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetAdAgencySettlementReportListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetAdAgencySettlementReportListQuery, TError, TData>({
    queryKey: ['GetAdAgencySettlementReportList', variables],
    queryFn: gql<Types.GetAdAgencySettlementReportListQuery, Types.GetAdAgencySettlementReportListQueryVariables>(
      GetAdAgencySettlementReportListDocument,
      variables,
    ),
    ...options,
  });
};

useGetAdAgencySettlementReportListQuery.getKey = (variables: Types.GetAdAgencySettlementReportListQueryVariables) => [
  'GetAdAgencySettlementReportList',
  variables,
];

export const GetBulkExcelDownloadRequestListDocument = `
    query GetBulkExcelDownloadRequestList($page: Int, $size: Int) {
  bulk_excel_download_requests_list(page: $page, size: $size) {
    total_count
    item_list {
      id
      template_name
      title
      parameters
      status
      file_name
      created_by
      updated_by
      date_created
      date_updated
    }
  }
}
    `;

export const useGetBulkExcelDownloadRequestListQuery = <
  TData = Types.GetBulkExcelDownloadRequestListQuery,
  TError = unknown,
>(
  variables?: Types.GetBulkExcelDownloadRequestListQueryVariables,
  options?: Omit<UseQueryOptions<Types.GetBulkExcelDownloadRequestListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.GetBulkExcelDownloadRequestListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.GetBulkExcelDownloadRequestListQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['GetBulkExcelDownloadRequestList'] : ['GetBulkExcelDownloadRequestList', variables],
    queryFn: gql<Types.GetBulkExcelDownloadRequestListQuery, Types.GetBulkExcelDownloadRequestListQueryVariables>(
      GetBulkExcelDownloadRequestListDocument,
      variables,
    ),
    ...options,
  });
};

useGetBulkExcelDownloadRequestListQuery.getKey = (variables?: Types.GetBulkExcelDownloadRequestListQueryVariables) =>
  variables === undefined ? ['GetBulkExcelDownloadRequestList'] : ['GetBulkExcelDownloadRequestList', variables];

export const AdAgencyControlListDocument = `
    query AdAgencyControlList($status: String!, $agency_account_id: ID, $search_keyword: String, $page: Int, $size: Int) {
  ad_agency_control_status_list(
    status: $status
    agency_account_id: $agency_account_id
    search_keyword: $search_keyword
    page: $page
    size: $size
  ) {
    total_count
    item_list {
      shop_name
      shop_domain
    }
  }
}
    `;

export const useAdAgencyControlListQuery = <TData = Types.AdAgencyControlListQuery, TError = unknown>(
  variables: Types.AdAgencyControlListQueryVariables,
  options?: Omit<UseQueryOptions<Types.AdAgencyControlListQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<Types.AdAgencyControlListQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<Types.AdAgencyControlListQuery, TError, TData>({
    queryKey: ['AdAgencyControlList', variables],
    queryFn: gql<Types.AdAgencyControlListQuery, Types.AdAgencyControlListQueryVariables>(
      AdAgencyControlListDocument,
      variables,
    ),
    ...options,
  });
};

useAdAgencyControlListQuery.getKey = (variables: Types.AdAgencyControlListQueryVariables) => [
  'AdAgencyControlList',
  variables,
];

export const ChangeSellerAccountInfoDocument = `
    mutation ChangeSellerAccountInfo($input: ChangeSellerAccountInfoInput!) {
  change_seller_account_info: changeSellerAccountInfo(input: $input)
}
    `;

export const useChangeSellerAccountInfoMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    Types.ChangeSellerAccountInfoMutation,
    TError,
    Types.ChangeSellerAccountInfoMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    Types.ChangeSellerAccountInfoMutation,
    TError,
    Types.ChangeSellerAccountInfoMutationVariables,
    TContext
  >({
    mutationKey: ['ChangeSellerAccountInfo'],
    mutationFn: (variables?: Types.ChangeSellerAccountInfoMutationVariables) =>
      gql<Types.ChangeSellerAccountInfoMutation, Types.ChangeSellerAccountInfoMutationVariables>(
        ChangeSellerAccountInfoDocument,
        variables,
      )(),
    ...options,
  });
};

export function api_createAdAgencyAgencyManagerType(
  variables?: Types.CreateAdAgencyAgencyManagerTypeMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.CreateAdAgencyAgencyManagerTypeMutation, Types.CreateAdAgencyAgencyManagerTypeMutationVariables>(
    CreateAdAgencyAgencyManagerTypeDocument,
    variables,
    options,
  )();
}

export function api_deleteAdAgencyAgencyManager(
  variables?: Types.DeleteAdAgencyAgencyManagerMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.DeleteAdAgencyAgencyManagerMutation, Types.DeleteAdAgencyAgencyManagerMutationVariables>(
    DeleteAdAgencyAgencyManagerDocument,
    variables,
    options,
  )();
}

export function api_inviteAdAgencyMarketer(
  variables?: Types.InviteAdAgencyMarketerMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.InviteAdAgencyMarketerMutation, Types.InviteAdAgencyMarketerMutationVariables>(
    InviteAdAgencyMarketerDocument,
    variables,
    options,
  )();
}

export function api_requestAdAgencyControlStatus(
  variables?: Types.RequestAdAgencyControlStatusMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.RequestAdAgencyControlStatusMutation, Types.RequestAdAgencyControlStatusMutationVariables>(
    RequestAdAgencyControlStatusDocument,
    variables,
    options,
  )();
}

export function api_removeAdAgencyFromSellerAccount(
  variables: Types.RemoveAdAgencyFromSellerAccountMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.RemoveAdAgencyFromSellerAccountMutation, Types.RemoveAdAgencyFromSellerAccountMutationVariables>(
    RemoveAdAgencyFromSellerAccountDocument,
    variables,
    options,
  )();
}

export function api_downloadAdAgencyAdAllPerformanceReportList(
  variables: Types.DownloadAdAgencyAdAllPerformanceReportListMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.DownloadAdAgencyAdAllPerformanceReportListMutation,
    Types.DownloadAdAgencyAdAllPerformanceReportListMutationVariables
  >(DownloadAdAgencyAdAllPerformanceReportListDocument, variables, options)();
}

export function api_downloadAdAgencyAdTopStorePerformanceReportList(
  variables: Types.DownloadAdAgencyAdTopStorePerformanceReportListMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.DownloadAdAgencyAdTopStorePerformanceReportListMutation,
    Types.DownloadAdAgencyAdTopStorePerformanceReportListMutationVariables
  >(DownloadAdAgencyAdTopStorePerformanceReportListDocument, variables, options)();
}

export function api_downloadAdAgencyAdMarketerPerformanceReportList(
  variables: Types.DownloadAdAgencyAdMarketerPerformanceReportListMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.DownloadAdAgencyAdMarketerPerformanceReportListMutation,
    Types.DownloadAdAgencyAdMarketerPerformanceReportListMutationVariables
  >(DownloadAdAgencyAdMarketerPerformanceReportListDocument, variables, options)();
}

export function api_downloadAdAgencySettlementReportList(
  variables: Types.DownloadAdAgencySettlementReportListMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.DownloadAdAgencySettlementReportListMutation,
    Types.DownloadAdAgencySettlementReportListMutationVariables
  >(DownloadAdAgencySettlementReportListDocument, variables, options)();
}

export function api_createAgencyWithAccount(
  variables: Types.CreateAgencyWithAccountMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.CreateAgencyWithAccountMutation, Types.CreateAgencyWithAccountMutationVariables>(
    CreateAgencyWithAccountDocument,
    variables,
    options,
  )();
}

export function api_requestBulkExcelDownload(
  variables: Types.RequestBulkExcelDownloadMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.RequestBulkExcelDownloadMutation, Types.RequestBulkExcelDownloadMutationVariables>(
    RequestBulkExcelDownloadDocument,
    variables,
    options,
  )();
}

export function api_getBulkExcelDownloadUrl(
  variables: Types.GetBulkExcelDownloadUrlMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetBulkExcelDownloadUrlMutation, Types.GetBulkExcelDownloadUrlMutationVariables>(
    GetBulkExcelDownloadUrlDocument,
    variables,
    options,
  )();
}

export function api_getAdAgency(variables?: Types.GetAdAgencyQueryVariables, options?: GqlRequestHeaders) {
  return gql<Types.GetAdAgencyQuery, Types.GetAdAgencyQueryVariables>(GetAdAgencyDocument, variables, options)();
}

export function api_getAdAgencyList(variables?: Types.GetAdAgencyListQueryVariables, options?: GqlRequestHeaders) {
  return gql<Types.GetAdAgencyListQuery, Types.GetAdAgencyListQueryVariables>(
    GetAdAgencyListDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyControlStatus(
  variables?: Types.GetAdAgencyControlStatusQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencyControlStatusQuery, Types.GetAdAgencyControlStatusQueryVariables>(
    GetAdAgencyControlStatusDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencySalesList(
  variables: Types.GetAdAgencySalesListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencySalesListQuery, Types.GetAdAgencySalesListQueryVariables>(
    GetAdAgencySalesListDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyMarketerList(
  variables?: Types.GetAdAgencyMarketerListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencyMarketerListQuery, Types.GetAdAgencyMarketerListQueryVariables>(
    GetAdAgencyMarketerListDocument,
    variables,
    options,
  )();
}

export function api_getAdPartnerShopContact(
  variables: Types.GetAdPartnerShopContactQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdPartnerShopContactQuery, Types.GetAdPartnerShopContactQueryVariables>(
    GetAdPartnerShopContactDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyNoticeList(
  variables?: Types.GetAdAgencyNoticeListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencyNoticeListQuery, Types.GetAdAgencyNoticeListQueryVariables>(
    GetAdAgencyNoticeListDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyPenaltyList(
  variables?: Types.GetAdAgencyPenaltyListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencyPenaltyListQuery, Types.GetAdAgencyPenaltyListQueryVariables>(
    GetAdAgencyPenaltyListDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyNotice(variables: Types.GetAdAgencyNoticeQueryVariables, options?: GqlRequestHeaders) {
  return gql<Types.GetAdAgencyNoticeQuery, Types.GetAdAgencyNoticeQueryVariables>(
    GetAdAgencyNoticeDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyAdPerformanceInfo(
  variables: Types.GetAdAgencyAdPerformanceInfoQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencyAdPerformanceInfoQuery, Types.GetAdAgencyAdPerformanceInfoQueryVariables>(
    GetAdAgencyAdPerformanceInfoDocument,
    variables,
    options,
  )();
}

export function api_getAdAgencyAdAllPerformanceReportList(
  variables: Types.GetAdAgencyAdAllPerformanceReportListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.GetAdAgencyAdAllPerformanceReportListQuery,
    Types.GetAdAgencyAdAllPerformanceReportListQueryVariables
  >(GetAdAgencyAdAllPerformanceReportListDocument, variables, options)();
}

export function api_getAdAgencyAdMarketerPerformanceReportList(
  variables: Types.GetAdAgencyAdMarketerPerformanceReportListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.GetAdAgencyAdMarketerPerformanceReportListQuery,
    Types.GetAdAgencyAdMarketerPerformanceReportListQueryVariables
  >(GetAdAgencyAdMarketerPerformanceReportListDocument, variables, options)();
}

export function api_getAdAgencyAdTopStorePerformanceReportList(
  variables: Types.GetAdAgencyAdTopStorePerformanceReportListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.GetAdAgencyAdTopStorePerformanceReportListQuery,
    Types.GetAdAgencyAdTopStorePerformanceReportListQueryVariables
  >(GetAdAgencyAdTopStorePerformanceReportListDocument, variables, options)();
}

export function api_getAdAgencySalesPerformanceReportList(
  variables: Types.GetAdAgencySalesPerformanceReportListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<
    Types.GetAdAgencySalesPerformanceReportListQuery,
    Types.GetAdAgencySalesPerformanceReportListQueryVariables
  >(GetAdAgencySalesPerformanceReportListDocument, variables, options)();
}

export function api_getAdAgencySettlementReportList(
  variables: Types.GetAdAgencySettlementReportListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetAdAgencySettlementReportListQuery, Types.GetAdAgencySettlementReportListQueryVariables>(
    GetAdAgencySettlementReportListDocument,
    variables,
    options,
  )();
}

export function api_getBulkExcelDownloadRequestList(
  variables?: Types.GetBulkExcelDownloadRequestListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.GetBulkExcelDownloadRequestListQuery, Types.GetBulkExcelDownloadRequestListQueryVariables>(
    GetBulkExcelDownloadRequestListDocument,
    variables,
    options,
  )();
}

export function api_adAgencyControlList(
  variables: Types.AdAgencyControlListQueryVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.AdAgencyControlListQuery, Types.AdAgencyControlListQueryVariables>(
    AdAgencyControlListDocument,
    variables,
    options,
  )();
}

export function api_changeSellerAccountInfo(
  variables: Types.ChangeSellerAccountInfoMutationVariables,
  options?: GqlRequestHeaders,
) {
  return gql<Types.ChangeSellerAccountInfoMutation, Types.ChangeSellerAccountInfoMutationVariables>(
    ChangeSellerAccountInfoDocument,
    variables,
    options,
  )();
}
